import Button from 'components/general/Button/Button';
import Flash from 'components/general/Flash/Flash';
import Icon from 'components/general/Icon/Icon';
import Can from 'containers/Can/Can';
import React from 'react';

/**
 * Intro for users who have yet to set Dashboard preferences.
 */
const DashboardIntro = ({ marketingUrl }) => (
  <div className="page-section">
    <Can
      action="update"
      on="Dashboard"
      fallbackRender={
        <Flash
          type="accent"
          message="To create a personal risk dashboard, and access further tools
           to assess your security risks, subscribe to GSI."
          actions={[{
            title: 'Find out more',
            types: ['accent'],
            to: marketingUrl,
            event: 'Clicked Dashboard Find Out More button',
          }]}
        />
      }
    >
      <p>
        Choose which ratings, alerts and articles you want to see by
        setting the geographies you are interested in.
      </p>
      <Button
        to={{
          type: 'PREFERENCES_INTERESTS',
        }}
      >
        <Icon name="settings" types={['push-right']} />
        Set preferences
      </Button>
    </Can>
  </div>
);

export default DashboardIntro;

